export enum ResponseStatuses {
  NotFound = 404,
  Unprocessable = 422,
}
